export default "__VITE_ASSET__DVsKnjfJ__"